import type { ItemModel } from 'api/client'
import { ICommonFilterModel } from 'shared/models/Common'

export type RecipientOpenState = 'SMS' | 'Email' | 'Message' | null
interface IRecipientBase {
  nameId: string
  name: string
  email: string
  phonenumber: string
  address: string
}

export interface IRecipientModel extends IRecipientBase {
  unitPropertyNo: string
  reservedAgainstElectronicCommunication: boolean
  // Only where filters.filterType === FilterTypeEnum.BoardMembers
  memberFunction?: string
  objectOrMeter?: ItemModel[]
  companyName?: string
  position?: string
  ssbNo?: string
  hasSignedIn?: boolean
  unitIds?: string[]
}

export interface IRecipientQueryModel extends ICommonFilterModel {
  filterType?: FilterTypeEnum | null
  // Can be used in conjuction with filtertypes owners and tenants
  addressId: number | null
  // Combine with extended query to query contacts by buildingtype id
  buildingTypeId?: number | null
  // BoardId
  boardId?: string | null
  // Objects
  objectTypeNo?: number | null
  // Meters
  meterTypeNo?: number | null
  // BuildingId
  buildingId?: number | null
}

export interface IBuildingTypes {
  type: string
  id: number | null
}

export enum MessageTypeEnum {
  SMS = 1,
  Email = 0,
}

export enum RecipientsSortByEnum {
  Name = 'name',
  UnitPropertyNo = 'propertySectionNo',
  UnitSsbNo = 'ssbNo',
  Email = 'email',
  Phonenumber = 'phonenumber',
  Address = 'address',
  // Handle board contacts filters
  CompanyName = 'companyName',
  Position = 'position',
  Reservation = 'reservedAgainstElectronicCommunication',
}

export enum FilterTypeEnum {
  Owners = 'Owners',
  Tenants = 'Tenants',
  Cohabitant = 'Cohabitant',
  BoardMembers = 'BoardMembers',
  Objects = 'Objects',
  Meters = 'Meters',
  BoardContacts = 'BoardContacts',
  OtherContacts = 'OtherContacts',
  BuildingTypes = 'BuildingTypes',
}
